import { render } from "./ArticleTitle.vue?vue&type=template&id=07050832&scoped=true"
import script from "./ArticleTitle.vue?vue&type=script&lang=js"
export * from "./ArticleTitle.vue?vue&type=script&lang=js"

import "./ArticleTitle.vue?vue&type=style&index=0&id=07050832&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07050832"]])

export default __exports__